import PropTypes from 'prop-types';

import Text from '@zenbusiness/zui/Text';

import BusinessInfoFieldset from '#client/components/BusinessInfoFieldset';
import { hasBusinessNameSuffix, ENTITY_TYPES } from '#client/utils/businessInfo';

const fieldsConfig = {
  businessName: {
    show: true,
    validation: {
      validate: (value) => {
        // TODO: translate strings. See BusinessInfoBOI
        const suffix = hasBusinessNameSuffix(value);
        return (
          !suffix || `Please don't include the company indicator (${suffix}) in your business name.`
        );
      }
    }
  },
  companyIndicator: {
    show: true,
    entityType: ENTITY_TYPES.LLC.value,
    defaultValue: 'LLC'
  },
  // Hidden fields
  entityType: { show: false },
  formationCounty: { show: false },
  jurisdictionState: { show: false }
};

function EditView({ sectionKey }) {
  // TODO: translate strings
  const tooltip =
    "You're required by law to add a company indicator to your business name. LLC is the most popular choice.";

  return (
    <>
      <Text component="p">{tooltip}</Text>
      <BusinessInfoFieldset fieldsConfig={fieldsConfig} namePrefix={sectionKey} />
    </>
  );
}

EditView.propTypes = {
  sectionKey: PropTypes.string.isRequired
};

export default EditView;
